<template>
  <div class="story">
    <div :style="largeScreenContainer">
      <v-container>
        <v-row>
          <v-col>
            <div class="story-desc">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et
            </div>
            <IconBrands v-if="$vuetify.breakpoint.smAndDown" />
            <div v-else class="story-brands">
              <IconGoogle />
              <IconDropbox />
              <IconUber />
              <IconMicrosoft />
              <IconFacebook />
            </div>
            <div v-if="$vuetify.breakpoint.smAndDown" class="story-title">
              Lorem ipsum dolor sit
            </div>
            <div v-else class="story-title">
              Lorem ipsum dolor sit amet
            </div>
            <p v-if="$vuetify.breakpoint.smAndDown" class="story-desc-second">
              Lorem ipsum dolor sit amet, consetetur
            </p>
            <p v-else class="story-desc-second">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="story-brands-body">
              <div class="story-brands-body-img-wrapper">
                <img src="@/assets/img/pricing-hero.jpg" alt="" />
                <div class="story-widget">
                  <div class="story-widget-tag">
                    LOREM IPSUM DOLOR SIT AMET
                  </div>
                  <div
                    v-if="$vuetify.breakpoint.smAndDown"
                    class="story-widget-title"
                  >
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor
                  </div>
                  <div v-else class="story-widget-title">
                    Lorem ipsum dolor sit <br />
                    amet, consetetur
                  </div>
                  <div class="story-widget-url">
                    <span>Read the story </span>
                    <IconArrowRight />
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="!$vuetify.breakpoint.smAndDown">
          <v-col>
            <div class="articles-slider-wrapper">
              <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide v-for="(n, idx) in 10" :key="idx">
                  <div class="articles-item">
                    <img src="@/assets/img/article.jpg" alt="" />
                    <div class="articles-item-content">
                      Lorem ipsum dolor
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="swiper-button-prev" slot="button-prev">
                <IconPurplePrev />
              </div>
              <div class="swiper-button-next" slot="button-next">
                <IconPurpleNext />
              </div>
              <div
                class="swiper-pagination swiper-story-pagination"
                slot="pagination"
              ></div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <div v-if="$vuetify.breakpoint.smAndDown" class="articles-slider-wrapper">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(n, idx) in 10" :key="idx">
            <div class="articles-item">
              <img src="@/assets/img/article.jpg" alt="" />
              <div class="articles-item-content">
                Lorem ipsum dolor
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev">
          <IconPurplePrev />
        </div>
        <div class="swiper-button-next" slot="button-next">
          <IconPurpleNext />
        </div>
        <div
          class="swiper-pagination swiper-story-pagination"
          slot="pagination"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOptions: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-story-pagination",
        },
        breakpoints: {
          1024: {
            spaceBetween: 28,
            slidesPerView: 5,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 3,
            spaceBetween: 18,
          },
        },
        loop: true,
        autoplay: {
          delay: 2500,
        },
      },
    };
  },
  components: {
    IconGoogle: () => import("@/components/icons/IconGoogle"),
    IconFacebook: () => import("@/components/icons/IconFacebook"),
    IconDropbox: () => import("@/components/icons/IconDropbox"),
    IconMicrosoft: () => import("@/components/icons/IconMicrosoft"),
    IconUber: () => import("@/components/icons/IconUber"),
    IconArrowRight: () => import("@/components/icons/IconArrowRight"),
    IconPurpleNext: () => import("@/components/icons/IconPurpleNext"),
    IconPurplePrev: () => import("@/components/icons/IconPurplePrev"),
    IconBrands: () => import("@/components/icons/IconBrands"),
  },
};
</script>

<style lang="scss">
.story {
  padding: 44px 0;
  text-align: center;

  &-desc {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 44px;
  }
  &-brands {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 86px;

    .icon {
      &:not(:last-child) {
        margin-right: 27px;
      }
    }
  }
  &-title {
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 27px;
  }
  &-desc-second {
    font-size: 24px;
    color: #575452;
    margin-bottom: 48px;
  }
  &-brands-body {
    margin-bottom: 40px;
    text-align: left;
    margin-top: 20px;
    padding-left: 48px;

    &-img-wrapper {
      height: 480px;
      width: 855px;
      position: relative;

      img {
        height: 100%;
      }
    }
  }
  &-widget {
    background-color: #fff;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(45%, -50%);
    padding: 67px 64px;

    &-tag {
      font-size: 12px;
      font-weight: 300;
      margin-bottom: 20px;
    }
    &-title {
      font-size: 30px;
      font-weight: bold;
      color: #0f0c09;
      margin-bottom: 62px;
    }
    &-url {
      color: #600dff;
      font-size: 14px;
      display: flex;
      align-items: center;
      span {
        margin-right: 5px;
      }
    }
  }

  .swiper-story-pagination {
    display: none;
  }
}
.articles {
  &-slider-wrapper {
    position: relative;

    .swiper-button-next,
    .swiper-button-prev {
      width: 42px !important;
      height: 42px !important;
      outline: none;
      &:after {
        display: none;
      }
    }

    .swiper-button-prev {
      left: -70px;
    }
    .swiper-button-next {
      right: -70px;
    }
  }
  &-item {
    height: 117px;
    position: relative;
    cursor: pointer;

    &:hover {
      .articles-item-content {
        opacity: 1;
        transform: translateY(0);
      }
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    &-content {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(96, 13, 255, 0.78);
      display: grid;
      place-items: center;
      color: #fff;
      opacity: 0.5;
      transition: all 0.3s ease-in-out;
      transform: translateY(100%);
    }
  }
}

@include smMax {
  .story {
    padding-bottom: 80px;
    &-desc {
      font-size: 16px;
    }
    &-title {
      font-size: 30px;
      margin-top: 50px;
    }
    &-desc-second {
      font-size: 18px;
    }
    &-brands-body {
      padding-left: 12px;
      margin-bottom: 130px;
    }
    &-brands-body-img-wrapper {
      width: 100%;
      height: 185px;
    }
    &-widget {
      left: 0;
      right: auto;
      transform: none;
      z-index: 2;
      top: 75%;
      padding: 18px 22px;
      padding-left: 0;

      &-tag {
        font-size: 10px;
      }

      &-title {
        font-size: 16px;
        max-width: 230px;
        margin-bottom: 14px;
      }
    }
  }

  .articles-item {
    height: 84px;
    width: 150px;
    margin: 0 auto;
  }
  .articles-slider-wrapper {
    .swiper-slide {
      width: 150px !important;
    }
    .swiper-button-next,
    .swiper-button-prev {
      display: none;
    }
    .swiper-pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      margin-top: 28px;

      .swiper-pagination-bullet {
        margin: 0 3px;
        transition: all 0.2s;
        height: 6px;
        width: 6px;
      }
      .swiper-pagination-bullet-active {
        background-color: $primary-color;
        height: 10px;
        width: 10px;
      }
    }
  }
}
</style>
